<template>
	<a class="dropdown-item py-2 px-0" @click="$bus.$emit('toggle-tenant-settings')">Settings</a>
</template>

<script>
	export default {
		name: "TenantSettingsTrigger",
		data() {
			return {}
		},
	}
</script>
